"use client";

import { BriefcaseBusiness, Home, LayoutPanelLeft, Mail } from "lucide-react";
import { FloatingNav } from "@/components/ui/FloatingNav";
import { GlowingEffect } from "@/components/ui/GlowingEffect";

const navItems = [
  {
    name: "Home",
    href: "/",
    icon: <Home size={28} />
  },
  {
    name: "Experience",
    href: "/experience",
    icon: <BriefcaseBusiness size={28} />
  },
  {
    name: "Projects",
    href: "/projects",
    icon: <LayoutPanelLeft size={28} />
  },
  {
    name: "Contact",
    href: "/contact",
    icon: <Mail size={28} />
  }
];
export function AppBar() {
  return (
    <header className="relative">
      <FloatingNav navItems={navItems} />
    </header>
  );
}
